<script setup lang="ts">
import { IonInput } from '@ionic/vue';
import { ref } from 'vue';

export type TextFieldTypes = 'text' | 'password' | 'email' | 'search' | 'tel' | 'url';
export type InputModeTypes = 'text' | 'email' | 'search' | 'tel' | 'url' | 'none' | 'numeric' | 'decimal' | undefined;

defineProps<{
  placeholder?: string;
  type?: TextFieldTypes;
  icon?: string;
  iconColorClass?: string;
  id?: string;
  disabled?: boolean;
  excludeBorders?: boolean;
  inputmode?: InputModeTypes;
}>();

defineEmits<{
  (e: 'onEnter'): void;
}>();

const modelValue = defineModel<string | number | undefined>();
const ionInputRef = ref();

function focus() {
  return ionInputRef.value?.$el?.setFocus();
}
const isFocused = ref(false);

function onInput(ev: any) {
  const value = ev.detail!.value;
  modelValue.value = value;
  if (ionInputRef.value) {
    ionInputRef.value.$el.value = value;
  }
}

defineExpose({
  focus,
  isFocused,
});
</script>

<template>
  <div
    class="relative w-full rounded"
    :class="{
      'bg-gray-100': disabled,
      'bg-white': !disabled,
      'border-2 border-gray-300': !excludeBorders,
    }"
  >
    <div v-if="icon" class="absolute left-0 top-0 h-full w-10 flex items-center justify-center z-10">
      <i :class="icon + ' ' + (iconColorClass || 'text-gray-500')"></i>
    </div>
    <ion-input
      ref="ionInputRef"
      @ion-blur="isFocused = false"
      @ion-focus="isFocused = true"
      :value="modelValue"
      @ion-input="onInput($event)"
      class="custom-base"
      :inputmode="inputmode"
      :type="type || 'text'"
      :placeholder="placeholder"
      :disabled="disabled"
      @keydown.enter="$emit('onEnter')"
    ></ion-input>
  </div>
</template>

<style>
.native-input:disabled {
  opacity: 1;
}
ion-input.custom-base.input-disabled {
  --color: #6b625e;
  --opacity: 1;
  opacity: 1;
}
ion-input.custom-base {
  --background: transparent;
  --border-color: transparent;
  --color: #6b625e;
  --placeholder-color: #bfbcb8;
  --placeholder-opacity: 1;
  --highlight-color-valid: #0477be;
  --highlight-color-focused: #0477be;
  --highlight-color-invalid: #ee939c;
  --padding-start: 40px;
  --border-radius: 0.25rem;
}
</style>
